import styled from 'styled-components'
import { Form } from 'react-bootstrap'

const MOBILE_BREAKPOINT = '767px'

export const Label = styled.label`
  color: var(--text-secondary, #464646);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin-bottom: 4px;
  display: block;

  span.required {
    color: #dc3545;
    margin-left: 2px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 13px;
    margin-bottom: 2px;
    line-height: 1.3;
  }
`

export const SelectWrapper = styled.div`
  position: relative;
`

export const StyledSelect = styled(Form.Select)<{ $isInvalid?: boolean }>`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid ${({ $isInvalid }) => ($isInvalid === true ? '#dc3545' : '#ced4da')};
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-tap-highlight-color: transparent;

  &:disabled {
    background-color: #f8f9fa;
    color: #6c757d;
    cursor: not-allowed;
  }

  option {
    font-size: 1rem;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0.25rem 0.4rem;
    min-height: 34px;
    font-size: 14px !important;
    border-radius: 0.25rem;
    line-height: 1.35;

    option {
      font-size: 14px;
    }
  }
`

export const LoadingText = styled.span`
  display: block;
  font-size: 13px;
  color: #6c757d;
  margin-top: 4px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 11px;
  }
`

export const ErrorFeedback = styled.div`
  display: block;
  width: 100%;
  margin-top: 4px;
  font-size: 0.875em;
  color: #dc3545;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 11px;
  }
`
